import React from 'react';
import Header from "../components/layout/Header";
import NotFoundIcon from "../assets/Images/not-found.png"
import Wrapper from "../components/layout/Wrapper";
import Footer from "../components/layout/Footer";
import {Helmet} from "react-helmet-async";


const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>صفحه مورد نظر پیدا نشد - کدپرو</title>
            </Helmet>

            <div className='flex flex-col min-h-screen'>
                <Header/>
                <Wrapper className='flex-1 my-10'>
                    <div className='w-1/2 mx-auto relative'>
                        <img src={NotFoundIcon} alt='Article not found' className='w-3/4 mx-auto'/>
                        <p className='text-3xl text-center mt-8'>صفحه مورد نظر پیدا نشد...</p>
                    </div>
                </Wrapper>
                <Footer/>
            </div>
        </>
    );
};

export default NotFound;
